import { Injectable } from '@angular/core';
import { BaseService } from '@app/shared/services/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CopyWorkOrderToCustomerInput } from '@app/core/models';
import { WorkOrder } from '@app/core/models/work-order.model';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderService extends BaseService {
  constructor(protected http: HttpClient) {
    super('work-orders', http);
  }

  getAllByCustomerId(id: number): Observable<WorkOrder[]> {
    const params = new HttpParams().set('customerId', id);
    return this.http.get<WorkOrder[]>(this.resourceUrl, { params });
  }

  getToday(): Observable<WorkOrder[]> {
    const params = new HttpParams().set('today', 'true');
    return this.http.get<WorkOrder[]>(this.resourceUrl, { params });
  }

  getByDate(date: Date): Observable<WorkOrder[]> {
    // Format as YYYY-MM-DD
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    const params = new HttpParams().set('date', `${year}-${month}-${day}`);
    return this.http.get<WorkOrder[]>(this.resourceUrl, { params });
  }

  complete<T>(data: { id: number }): Observable<T> {
    return this.http.post<T>(`${this.resourceUrl}/${data.id}/complete`, {});
  }

  duplicate<T>(data: { id: number }): Observable<T> {
    return this.http.post<T>(`${this.resourceUrl}/${data.id}/duplicate`, {});
  }

  copyToCustomer<T>(data: CopyWorkOrderToCustomerInput): Observable<T> {
    return this.http.post<T>(`${this.resourceUrl}/${data.workOrderId}/copy`, {
      customerId: data.customerId,
      buildingId: data.buildingId,
    });
  }
}
